import React from "react"
import { Link } from "gatsby"
import { useHits, Highlight } from "react-instantsearch"
import { Ep } from "../el/searchelements"

// product hit component
const CustomProductHits = () => {
  const { items } = useHits()

  return items.length === 0 ? (
    <Ep>Your search yields no results, try searching something else.</Ep>
  ) : (
    items.map(item => {
      return (
        <Link
          key={item.objectID}
          to={item.slug}
          className="flex items-center border-b border-gray-200 px-2 py-1.5"
        >
          <div className="mr-2.5 h-16 w-16 shrink-0 overflow-hidden rounded-full shadow-md">
            {item.image && (
              <div className="h-full w-full overflow-hidden rounded-full">
                <img
                  alt={item.title}
                  src={`/product-thumbnails/${item.image}`}
                  className="rounded-full"
                />
              </div>
            )}
          </div>
          <div>
            <h3 className="truncate text-sm font-medium text-gray-800">
              <Highlight
                hit={item}
                attribute="title"
                highlightedTagName="mark"
              />
            </h3>
            <p className="text-xs font-light text-gray-700">
              <Highlight
                hit={item}
                attribute="description"
                highlightedTagName="mark"
              />
            </p>
            <p className="text-xs font-light text-gray-700">
              <Highlight
                hit={item}
                attribute="descriptionSub"
                highlightedTagName="mark"
              />
            </p>
            <p className="text-xs font-light text-slate-500">
              <span className="font-bold">part #:</span>{" "}
              <Highlight
                hit={item}
                attribute="partNumber"
                highlightedTagName="mark"
              />
            </p>
          </div>
        </Link>
      )
    })
  )
}

export default CustomProductHits
